import {Component, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewChecked, ChangeDetectorRef, OnInit, inject} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";
import {MediaHelperService} from "../../../../core/media-helper.service";

@Component({
    selector: 'report-preview-catalogue',
    templateUrl: './report-preview-catalogue.component.html',
    styleUrls: ['./report-preview-catalogue.component.scss'],
    standalone: false
})
export class ReportPreviewCatalogueComponent implements OnInit, OnChanges, AfterViewChecked {
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly mediaService: MediaHelperService = inject(MediaHelperService);

  @ViewChild('reportContainer', { static: false }) reportContainer: ElementRef;
  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;

  private inputsSet = false;
  private viewInitialized = false;
  private readonly defaultReportViewOptions : { [key: string]: any } = { "vis_ledetekster": true, "høyrejuster_bilder": true, "ledetekst_og_verdi_på_en_linje": true, "vis_seksjonstitler": true};
  imageUrls : Map<string, string> = new Map();

  ngOnInit(): void {
    //If Report View Options is NULL, select default values, if empy string, leave empty
    if (!this.reportTemplate.reportViewOptions) {
      this.reportTemplate.reportViewOptions = this.defaultReportViewOptions;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reportTemplate || changes.extractedArtifacts) {
      if (this.extractedArtifacts && this.extractedArtifacts.length > 0) {
        let emptyImageIds = [];

        this.extractedArtifacts.forEach(artifact => {
          if (artifact.images && artifact.images.length > 0) {
            const imageIds = artifact.images.map(image => image.image_id);
            imageIds.forEach(imageId => {
              if (!this.imageUrls.has(imageId)) {
                emptyImageIds.push(imageId);
              }
            });
          }
        });

        if (emptyImageIds.length > 0) {
          this.mediaService.getImageUrlsFromImageIds(emptyImageIds, ['medium']).then((urls) => {
            const keys = Object.keys(urls);
            keys.forEach((key) => {
              this.imageUrls.set(key, urls[key]['medium']);
            });
          });
        }
      }

      const previousFieldSections = changes.reportTemplate?.previousValue?.fieldSections;
      const currentFieldSections = changes.reportTemplate?.currentValue?.fieldSections;

      const previousIsSelectedValues = previousFieldSections ? previousFieldSections.map(section => section.isSelected).join(', ') : '';
      const currentIsSelectedValues = currentFieldSections ? currentFieldSections.map(section => section.isSelected).join(', ') : '';

      this.cdRef.detectChanges();

      if (previousIsSelectedValues !== currentIsSelectedValues) {
        this.cdRef.detectChanges();
      }

      this.inputsSet = this.reportTemplate != null && this.extractedArtifacts != null;
    }
  }

  ngAfterViewChecked() {
    if (this.inputsSet && !this.viewInitialized) {
      this.viewInitialized = true;
    }
  }

  isLeftAdjustedImages() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'venstrejusterte_bilder').value;
  }

  isHidePrompts() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'skjul_ledetekster').value;
  }

  isViewPromptSeparateLines() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'ledetekst_og_verdi_på_egne_linjer').value;
  }

  isViewWithFullImage() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'med_helbilde').value;
  }

  isShowSectionTitles() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'vis_seksjonstitler').value;
  }

}
